import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import PriorityIcon from '../../../../common/ui/priority-icon/index.tsx';
import type { ListViewControllerData } from '../../../../controllers/list-view-issues/types.tsx';
import messages from './messages.tsx';

export const PriorityItem = ({ data }: { data: ListViewControllerData }) => {
	const { formatMessage } = useIntl();
	const priorityName =
		data.priority?.name != null ? data.priority.name : formatMessage(messages.noPriority);

	return (
		<>
			<PriorityIcon iconUrl={data.priority?.iconUrl} />
			<PriorityLabel>{priorityName}</PriorityLabel>
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PriorityLabel = styled.span({
	marginLeft: token('space.100'),
});
